[
  {
    "id": "marker",
    "x": 644,
    "y": 976,
    "w": 166,
    "h": 70,
    "shape": {
      "kind": "pill",
      "n": [
        717,
        993,
        806,
        1032
      ],
      "glow": 12
    }
  }
]
